import React from 'react';
import {
	Drawer,
	DrawerCloseButton,
	DrawerContent,
	DrawerOverlay,
} from '@tempo/core';
import Sidebar from '@components/Sidebar/index';

type FloatingNavigationDrawerProps = {
	isOpen: boolean;
	onClose: () => void;
};

const MobileSidebar = ({isOpen, onClose}: FloatingNavigationDrawerProps) => {
	return (
		<Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
			<DrawerOverlay />
			<DrawerContent>
				<DrawerCloseButton />
				<Sidebar onMenuItemClick={onClose} isMobile={true} />
			</DrawerContent>
		</Drawer>
	);
};

export default MobileSidebar;
